import jimp from 'jimp';
import moment from "moment";

// convert image buffer to byte array
export const fillBytesFromImageBuffer = (imageBuffer) => {
    let bytes = new Uint8Array(imageBuffer.length);
    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = imageBuffer[i];
    }
    return bytes;
}

// set bytes into viewdata
export const viewDataUnit = (bytes) => {
    let view = new DataView(bytes.buffer);
    bytes.forEach(function (b, i) {
        view.setUint8(i, b);
    });
    return view;
}

// Fill imageBuffer Pixel temperature from view data
export const fillImgPixelTemp = (view) => {

    let num;
    let offset = 4;
    let imBuffer = [];
    let numPixel = 0;

    for (let i = 0; i < view.byteLength; i += 4) {
        if (i + offset - 1 < view.byteLength) {
            num = view.getFloat32(i, true);
            imBuffer[numPixel] = num.toFixed(2);
            numPixel++;
        }
    }
    return imBuffer;
}

// Return the pixel matrix with temperature values 
export const loadImagerParameter = (imageData) => {

    // Decode base64
    const imageBuffer = new Buffer.from(imageData, 'base64')

    // Create byte array
    const bytes = fillBytesFromImageBuffer(imageBuffer);

    // Create a data view of bytes array 
    let view = viewDataUnit(bytes);

    // create image matrix pixel with Temperature value
    // generate new images
    return fillImgPixelTemp(view);
}

// Create Image from Temperature imBuffer array
export const createImageFromTempArray = (imBuffer, image, sizex, sizey, colorMap, scaleMin, scaleMax) => {
    //if (imBuffer.length == 0 ) return null;

    let numColors = colorMap.length;

    // let offset = scaleMax - scaleMin;

    let offset = (scaleMax - scaleMin) !== 0 ? scaleMax - scaleMin : 0.001;  // avoid undefined value

    for (let y = 0; y < sizey; y++) {
        for (let x = 0; x < sizex; x++) {
            let temp = imBuffer[(sizex) * y + x] - 273.15;

            if (temp > scaleMax)
                temp = scaleMax;
            if (temp < scaleMin)
                temp = scaleMin;

            let index = Math.round(Math.min((numColors * (temp - scaleMin)) / (offset), numColors - 1));
            if (!index) index = 0;
            image.setPixelColor(jimp.rgbaToInt(colorMap[index].r, colorMap[index].g, colorMap[index].b, 255), x, y);
        }
    }

    return image;
}


// Convert to chart  from unicode
// consult and look table: https://www.utf8-chartable.de/ 
export const convertUnicode = (input) => {
    return input.replace(/\\u[0-9a-fA-F]{4}/g, function (a, b) {
        var charcode = parseInt(b, 16);
        return String.fromCharCode(charcode);
    });
}


export const localDate = (date, languageSelected) => {

    let dateStr = "";

    switch (languageSelected) {
        case "fi":
            dateStr = moment((new Date(date))).format('HH:mm:ss');
            break;
        case "en":
            dateStr = moment((new Date(date))).format('HH:mm:ss');
            break;
        case "es":
            dateStr = moment((new Date(date))).format('HH:mm:ss');
            break;
        default:
            dateStr = moment((new Date(date))).format('HH:mm:ss');
    }
    return dateStr
}

export const localDateTime = (date, languageSelected) => {

    let dateStr = "";

    switch (languageSelected) {
        case "fi":
            dateStr = moment((new Date(date))).format('DD.MM.yy HH:mm:ss');
            break;
        case "en":
            dateStr = moment((new Date(date))).format('yy/MM/DD HH:mm:ss');
            break;
        case "es":
            dateStr = moment((new Date(date))).format('DD/MM/yy HH:mm:ss');
            break;
        default:
            dateStr = moment((new Date(date))).format('yy/MM/DD HH:mm:ss');
    }
    return dateStr
}

export const generateReportDatetime = (date, languageSelected) => {

    let dateStr = "";

    switch (languageSelected) {
        case "fi":
            dateStr = moment((new Date(date))).format('DDMMyyTHHmmss');
            break;
        case "en":
            dateStr = moment((new Date(date))).format('yyMMDDTHHmmss');
            break;
        case "es":
            dateStr = moment((new Date(date))).format('DDMMyyTHHmmss');
            break;
        default:
            dateStr = moment((new Date(date))).format('yyMMDDTHHmmss');
    }
    return dateStr
}